console.log("It works!");
